import React from 'react';
import { useTranslation } from 'react-i18next';
const LoginOrRegisterHeader = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "login-register-header" },
        React.createElement("button", { type: "button", "aria-label": t('button.back'), className: "modal__back", onClick: props.onBack }),
        React.createElement("h2", { className: "mt-20" }, props.step == 'email' ? t('login.loginregister') : props.step == 'register' ? t('login.registertomymoncler') : t('login.logintomymoncler'))));
};
export default LoginOrRegisterHeader;
